// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "3b6b56a9757723e463843c2fcbcba5bb" + ".js";
};